import { render, staticRenderFns } from "./uploadFileList.vue?vue&type=template&id=5274e96e&scoped=true"
import script from "./uploadFileList.vue?vue&type=script&lang=js"
export * from "./uploadFileList.vue?vue&type=script&lang=js"
import style0 from "./uploadFileList.vue?vue&type=style&index=0&id=5274e96e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5274e96e",
  null
  
)

export default component.exports